import { IconButton, Menu, MenuButton, MenuItem, MenuList } from '@chakra-ui/core';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { FiMoreVertical } from 'react-icons/fi';
import { useHistory } from 'react-router-dom';
import { PATH_QUESTIONNAIRE_TEMPLATE_COPY, PATH_QUESTIONNAIRE_TEMPLATE_EDIT } from '../../../../../routes/constants';

interface ActionCellProps {
  templateId: string;
  isDefault: boolean;
}

const ActionCell = ({ templateId, isDefault }: ActionCellProps) => {
  const history = useHistory();

  const { t } = useTranslation('administration');

  const handleEdit = () => {
    history.push(PATH_QUESTIONNAIRE_TEMPLATE_EDIT.replace(':templateId', templateId));
  };

  const handleCopy = () => {
    history.push(PATH_QUESTIONNAIRE_TEMPLATE_COPY.replace(':templateId', templateId));
  };

  return (
    <Menu placement="bottom-end">
      <MenuButton>
        <IconButton icon={<FiMoreVertical />} size="sm" variant="ghost" aria-label="Actions" />
      </MenuButton>

      <MenuList>
        {!isDefault && <MenuItem onClick={handleEdit}>{t('languageEvaluation.edit')}</MenuItem>}
        <MenuItem onClick={handleCopy}>{t('languageEvaluation.duplicate')}</MenuItem>
        {/* <MenuItem onClick={onHistoryChange}>{t('languageEvaluation.history')}</MenuItem> */}
      </MenuList>
    </Menu>
  );
};

export default ActionCell;
